export default __webpack_public_path__ + "static/media/pregnant-woman.b6114eec.jpeg";